import Breadcrumb from '@/components/breadcrumb';
import { Button } from '@/components/ui/button';
import { useStore } from '@nanostores/react';
import { PlusIcon } from 'lucide-react';
import { NewPortfolioModal } from './components/NewPortfolioModal';
import { PortfolioListing } from './components/PortfolioListing';

export type ManagePortfoliosProps = {
  organizationId: string;
};

export const ManagePortfolios = ({ organizationId }: ManagePortfoliosProps) => {
  const [showModal, setShowModal] = useState(false);

  const org = useStore($org);

  const pages = [
    {
      label: org?.name || 'Organizations',
      href: org?.name
        ? `/organization/${org?.id}/portfolios`
        : '/organizations',
    },
    {
      label: 'Account Groups',
      href: `/organization/${org?.id}/portfolios`,
    },
  ];

  return (
    <div>
      {/* Breadcrumb */}
      <h3 className="m-0 flex-1 p-0">
        <Breadcrumb pages={pages} />
      </h3>

      {/* Page Header with actions */}
      <div className=" mt-2 flex items-center justify-between space-y-2">
        <div>
          <h2 className="text-2xl font-bold tracking-tight">Accounts</h2>
          <p className="text-muted-foreground">
            {`Account Groups for ${org?.name}.`}
          </p>
        </div>
        <div className="flex items-center space-x-2">
          <Button onClick={() => setShowModal(true)}>
            <PlusIcon className="mr-2 h-4 w-4" /> Add New
          </Button>
        </div>
      </div>

      {/* Portfolio list */}
      <div className="mt-4 max-w-4xl">
        <PortfolioListing organizationId={org?.id || organizationId} />
      </div>

      {/* Create New Portfolio Modal */}
      <NewPortfolioModal
        open={showModal}
        setOpen={setShowModal}
        organizationId={org?.id || organizationId}
      />
    </div>
  );
};